import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';
import { readWelcomeQueue, advanceWelcomeQueue, clearWelcome, WELCOME_ROUTES } from './welcomeSteps';
import css from './WelcomeStepBar.module.css';

// "Step 1 of 3" line on each chosen area. ID check, card and payouts are once per account,
// so each area's own setup already skips steps that are done.
const WelcomeStepBar = () => {
  const { pathname } = useLocation();
  const [q, setQ] = useState(null);
  const history = useHistory();
  const routes = useRouteConfiguration();
  useEffect(() => { setQ(readWelcomeQueue()); }, [pathname]);
  if (!q || !q.queue?.length) return null;
  const key = q.queue[q.i];
  if (!key || !pathname.startsWith(WELCOME_ROUTES[key].path)) return null;
  const go = name => history.push(createResourceLocatorString(name, routes, {}, {}));
  const next = () => { const n = advanceWelcomeQueue(); setQ(n); go(n ? WELCOME_ROUTES[n.queue[n.i]].name : 'DashboardPage'); };
  const skip = () => { clearWelcome(); setQ(null); go('DashboardPage'); };
  const last = q.i + 1 >= q.queue.length;
  return (
    <div className={css.bar} data-welcome-step={key} role="status">
      <span className={css.count}>Step {q.i + 1} of {q.queue.length}</span>
      <span className={css.label}>{WELCOME_ROUTES[key].label}</span>
      <button type="button" className={css.next} onClick={next}>{last ? 'Finish ›' : `Next: ${WELCOME_ROUTES[q.queue[q.i + 1]].label} ›`}</button>
      <button type="button" className={css.skip} onClick={skip}>Skip to dashboard</button>
    </div>
  );
};
export default WelcomeStepBar;
